/* eslint-disable */
export const translationKeys = {
  primeng: {
    accept: 'primeng.accept',
    addRule: 'primeng.addRule',
    after: 'primeng.after',
    apply: 'primeng.apply',
    before: 'primeng.before',
    cancel: 'primeng.cancel',
    choose: 'primeng.choose',
    clear: 'primeng.clear',
    contains: 'primeng.contains',
    dayNames: [
      'primeng.dayNames.0',
      'primeng.dayNames.1',
      'primeng.dayNames.2',
      'primeng.dayNames.3',
      'primeng.dayNames.4',
      'primeng.dayNames.5',
      'primeng.dayNames.6'
    ],
    dayNamesMin: [
      'primeng.dayNamesMin.0',
      'primeng.dayNamesMin.1',
      'primeng.dayNamesMin.2',
      'primeng.dayNamesMin.3',
      'primeng.dayNamesMin.4',
      'primeng.dayNamesMin.5',
      'primeng.dayNamesMin.6'
    ],
    dayNamesShort: [
      'primeng.dayNamesShort.0',
      'primeng.dayNamesShort.1',
      'primeng.dayNamesShort.2',
      'primeng.dayNamesShort.3',
      'primeng.dayNamesShort.4',
      'primeng.dayNamesShort.5',
      'primeng.dayNamesShort.6'
    ],
    emptyFilterMessage: 'primeng.emptyFilterMessage',
    emptyMessage: 'primeng.emptyMessage',
    endsWith: 'primeng.endsWith',
    equals: 'primeng.equals',
    gt: 'primeng.gt',
    gte: 'primeng.gte',
    is: 'primeng.is',
    isNot: 'primeng.isNot',
    lt: 'primeng.lt',
    lte: 'primeng.lte',
    matchAll: 'primeng.matchAll',
    matchAny: 'primeng.matchAny',
    medium: 'primeng.medium',
    monthNames: [
      'primeng.monthNames.0',
      'primeng.monthNames.1',
      'primeng.monthNames.2',
      'primeng.monthNames.3',
      'primeng.monthNames.4',
      'primeng.monthNames.5',
      'primeng.monthNames.6',
      'primeng.monthNames.7',
      'primeng.monthNames.8',
      'primeng.monthNames.9',
      'primeng.monthNames.10',
      'primeng.monthNames.11'
    ],
    monthNamesShort: [
      'primeng.monthNamesShort.0',
      'primeng.monthNamesShort.1',
      'primeng.monthNamesShort.2',
      'primeng.monthNamesShort.3',
      'primeng.monthNamesShort.4',
      'primeng.monthNamesShort.5',
      'primeng.monthNamesShort.6',
      'primeng.monthNamesShort.7',
      'primeng.monthNamesShort.8',
      'primeng.monthNamesShort.9',
      'primeng.monthNamesShort.10',
      'primeng.monthNamesShort.11'
    ],
    noFilter: 'primeng.noFilter',
    notContains: 'primeng.notContains',
    notEquals: 'primeng.notEquals',
    passwordPrompt: 'primeng.passwordPrompt',
    reject: 'primeng.reject',
    removeRule: 'primeng.removeRule',
    startsWith: 'primeng.startsWith',
    strong: 'primeng.strong',
    today: 'primeng.today',
    upload: 'primeng.upload',
    weak: 'primeng.weak',
    weekHeader: 'primeng.weekHeader'
  },
  AvanoTable: {
    DefaultButtons: {
      Export: 'AvanoTable.DefaultButtons.Export',
      Refresh: 'AvanoTable.DefaultButtons.Refresh',
      Settings: 'AvanoTable.DefaultButtons.Settings'
    },
    Footer: {
      Pagination: {
        PageCountWithTotalTemplate: 'AvanoTable.Footer.Pagination.PageCountWithTotalTemplate'
      }
    },
    Settings: {
      Columns: {
        Label: 'AvanoTable.Settings.Columns.Label'
      },
      Pagination: {
        ItemsPerPageLabel: 'AvanoTable.Settings.Pagination.ItemsPerPageLabel'
      },
      ResetButtonLabel: 'AvanoTable.Settings.ResetButtonLabel'
    },
    TableHeader: {
      ResetAllFilters: 'AvanoTable.TableHeader.ResetAllFilters'
    },
    EmptyMessage: {
      noRecords: 'AvanoTable.EmptyMessage.noRecords',
      emptySearch: 'AvanoTable.EmptyMessage.emptySearch'
    }
  },
  appheader: {
    tooltip: {
      appSwitch: 'appheader.tooltip.appSwitch',
      logOut: 'appheader.tooltip.logOut',
      notifications: 'appheader.tooltip.notifications'
    }
  },
  appmenucomponent: {
    typescript: {
      dashboardLabel: 'appmenucomponent.typescript.dashboardLabel',
      dossierDefaults: 'appmenucomponent.typescript.dossierDefaults',
      echaProfileSetup: 'appmenucomponent.typescript.echaProfileSetup',
      productLabel: 'appmenucomponent.typescript.productLabel',
      scipPreferences: 'appmenucomponent.typescript.scipPreferences',
      submissionLabel: 'appmenucomponent.typescript.submissionLabel'
    }
  },
  articleCategorySelectDialogComponent: {
    html: {
      articleCategories: 'articleCategorySelectDialogComponent.html.articleCategories',
      availableArticleCategories: 'articleCategorySelectDialogComponent.html.availableArticleCategories',
      dialogTitle: 'articleCategorySelectDialogComponent.html.dialogTitle',
      selectedArticleCategories: 'articleCategorySelectDialogComponent.html.selectedArticleCategories',
      tariffTaricCode: 'articleCategorySelectDialogComponent.html.tariffTaricCode'
    }
  },
  articleCategoryTreeComponent: {
    html: {
      button: {
        search: 'articleCategoryTreeComponent.html.button.search'
      },
      description: 'articleCategoryTreeComponent.html.description',
      href: 'articleCategoryTreeComponent.html.href',
      noSearchResults: 'articleCategoryTreeComponent.html.noSearchResults',
      range: 'articleCategoryTreeComponent.html.range',
      tarifftariccode: 'articleCategoryTreeComponent.html.tarifftariccode'
    },
    typeScript: {
      tariffCode: 'articleCategoryTreeComponent.typeScript.tariffCode',
      textSearch: 'articleCategoryTreeComponent.typeScript.textSearch'
    }
  },
  avano: {
    component: {
      autocomplete: {
        emptymessage: {
          forceDialogSelection: 'avano.component.autocomplete.emptymessage.forceDialogSelection'
        }
      },
      combobox: {
        overlay: {
          createNew: 'avano.component.combobox.overlay.createNew',
          filter: 'avano.component.combobox.overlay.filter',
          filterCreate: 'avano.component.combobox.overlay.filterCreate'
        }
      }
    },
    errorsDetails: {
      common: {
        validations: {
          required: 'avano.errorsDetails.common.validations.required',
          maxLength: 'avano.errorsDetails.common.validations.maxLength',
          minLength: 'avano.errorsDetails.common.validations.minLength',
          maxValue: 'avano.errorsDetails.common.validations.maxValue',
          minValue: 'avano.errorsDetails.common.validations.minValue',
          unknownFallback: 'avano.errorsDetails.common.validations.unknownFallback'
        }
      },
      msg: {
        header: 'avano.errorsDetails.msg.header'
      },
      btn: {
        goTo: 'avano.errorsDetails.btn.goTo'
      }
    },
    buttonBar: {
      common: {
        btn: {
          error: 'avano.buttonBar.common.btn.error'
        }
      }
    },
    notifications: {
      btn: {
        download: 'avano.notifications.btn.download',
        showAll: 'avano.notifications.btn.showAll',
        showDetails: 'avano.notifications.btn.showDetails',
        unread: 'avano.notifications.btn.unread'
      },
      msg: {
        header: 'avano.notifications.msg.header'
      }
    }
  },
  avanoErrorPage: {
    button: {
      backToDashboard: 'avanoErrorPage.button.backToDashboard',
      backToLogin: 'avanoErrorPage.button.backToLogin'
    },
    msg: {
      header: {
        FORBIDDEN_403: 'avanoErrorPage.msg.header.FORBIDDEN_403',
        INTERNAL_SERVER_ERROR_500: 'avanoErrorPage.msg.header.INTERNAL_SERVER_ERROR_500',
        NOTFOUND_404: 'avanoErrorPage.msg.header.NOTFOUND_404',
        UNAUTHORIZED_401: 'avanoErrorPage.msg.header.UNAUTHORIZED_401'
      },
      txt: {
        FORBIDDEN_403: 'avanoErrorPage.msg.txt.FORBIDDEN_403',
        INTERNAL_SERVER_ERROR_500: 'avanoErrorPage.msg.txt.INTERNAL_SERVER_ERROR_500',
        NOTFOUND_404: 'avanoErrorPage.msg.txt.NOTFOUND_404',
        UNAUTHORIZED_401: 'avanoErrorPage.msg.txt.UNAUTHORIZED_401'
      }
    }
  },
  backendErrorService: {
    msg: {
      error: {
        SCIP_ERROR_UNKNOWN: 'backendErrorService.msg.error.SCIP_ERROR_UNKNOWN',
        SCIP_INVALID_PARAMETER: 'backendErrorService.msg.error.SCIP_INVALID_PARAMETER',
        SCIP_ORG_ENTITY_KEY_ALREADY_EXIST: 'backendErrorService.msg.error.SCIP_ORG_ENTITY_KEY_ALREADY_EXIST',
        SCIP_ORG_NAME_ALREADY_EXIST: 'backendErrorService.msg.error.SCIP_ORG_NAME_ALREADY_EXIST',
        SCIP_ORG_S2S_KEY_ALREADY_EXIST: 'backendErrorService.msg.error.SCIP_ORG_S2S_KEY_ALREADY_EXIST'
      },
      severity: {
        header: {
          ERROR: 'backendErrorService.msg.severity.header.ERROR',
          WARNING: 'backendErrorService.msg.severity.header.WARNING'
        }
      }
    }
  },
  commonTranslationKey: {
    btn: {
      apply: 'commonTranslationKey.btn.apply',
      cancel: 'commonTranslationKey.btn.cancel',
      close: 'commonTranslationKey.btn.close',
      error: 'commonTranslationKey.btn.error',
      save: 'commonTranslationKey.btn.save'
    },
    filter: {
      noResults: 'commonTranslationKey.filter.noResults'
    },
    validation: {
      error: {
        required: {
          input: 'commonTranslationKey.validation.error.required.input',
          selection: 'commonTranslationKey.validation.error.required.selection'
        }
      }
    }
  },
  dashboard: {
    bannerComponent: {
      html: {
        basicUserMessage: 'dashboard.bannerComponent.html.basicUserMessage',
        selectedOrganisationHeader: 'dashboard.bannerComponent.html.selectedOrganisationHeader'
      }
    },
    productTableComponent: {
      html: {
        header: 'dashboard.productTableComponent.html.header',
        showDetails: 'dashboard.productTableComponent.html.showDetails',
        showFullList: 'dashboard.productTableComponent.html.showFullList',
        table: {
          lastUpdated: 'dashboard.productTableComponent.html.table.lastUpdated',
          productName: 'dashboard.productTableComponent.html.table.productName',
          productNumber: 'dashboard.productTableComponent.html.table.productNumber'
        }
      }
    },
    productsBySubmissionStatus: {
      html: {
        header: 'dashboard.productsBySubmissionStatus.html.header',
        noEntryText: 'dashboard.productsBySubmissionStatus.html.noEntryText'
      },
      chart: {
        ts: {
          validated: 'dashboard.productsBySubmissionStatus.chart.ts.validated',
          failed: 'dashboard.productsBySubmissionStatus.chart.ts.failed',
          inProgress: 'dashboard.productsBySubmissionStatus.chart.ts.inProgress',
          noSubmission: 'dashboard.productsBySubmissionStatus.chart.ts.noSubmission'
        }
      }
    },
    recentSearchesComponent: {
      html: {
        header: 'dashboard.recentSearchesComponent.html.header'
      }
    },
    submissionTableComponent: {
      html: {
        header: 'dashboard.submissionTableComponent.html.header',
        showDetails: 'dashboard.submissionTableComponent.html.showDetails',
        showFullList: 'dashboard.submissionTableComponent.html.showFullList',
        table: {
          organization: 'dashboard.submissionTableComponent.html.table.organization',
          product: 'dashboard.submissionTableComponent.html.table.product',
          status: 'dashboard.submissionTableComponent.html.table.status',
          updated: 'dashboard.submissionTableComponent.html.table.updated'
        }
      }
    },
    submissionsByStatus: {
      html: {
        header: 'dashboard.submissionsByStatus.html.header',
        noEntryText: 'dashboard.submissionsByStatus.html.noEntryText'
      },
      chart: {
        ts: {
          validated: 'dashboard.submissionsByStatus.chart.ts.validated',
          failed: 'dashboard.submissionsByStatus.chart.ts.failed',
          inProgress: 'dashboard.submissionsByStatus.chart.ts.inProgress'
        }
      }
    },
    submissionsByOrganisation: {
      html: {
        header: 'dashboard.submissionsByOrganisation.html.header',
        noEntryText: 'dashboard.submissionsByOrganisation.html.noEntryText'
      },
      chart: {
        ts: {
          full: 'dashboard.submissionsByOrganisation.chart.ts.full',
          simplified: 'dashboard.submissionsByOrganisation.chart.ts.simplified'
        }
      }
    },
    submissionsByYear: {
      html: {
        header: 'dashboard.submissionsByYear.html.header',
        noEntryText: 'dashboard.submissionsByYear.html.noEntryText'
      },
      chart: {
        ts: {
          full: 'dashboard.submissionsByYear.chart.ts.full',
          simplified: 'dashboard.submissionsByYear.chart.ts.simplified'
        }
      }
    },
    userSettingsComponent: {
      html: {
        header: {
          dialogHeader: 'dashboard.userSettingsComponent.html.header.dialogHeader',
          listOfTableTiles: 'dashboard.userSettingsComponent.html.header.listOfTableTiles',
          listOfChartTiles: 'dashboard.userSettingsComponent.html.header.listOfChartTiles',
          listOfOtherTiles: 'dashboard.userSettingsComponent.html.header.listOfOtherTiles'
        },
        introduction: {
          title: 'dashboard.userSettingsComponent.html.introduction.title'
        },
        selectedOrganization: {
          title: 'dashboard.userSettingsComponent.html.selectedOrganization.title',
          description: 'dashboard.userSettingsComponent.html.selectedOrganization.description'
        },
        section: {
          title: 'dashboard.userSettingsComponent.html.section.title'
        }
      },
      typescript: {
        save: {
          success: 'dashboard.userSettingsComponent.typescript.save.success',
          error: 'dashboard.userSettingsComponent.typescript.save.error'
        }
      },
      openBtn: 'dashboard.userSettingsComponent.openBtn',
      organizationDropdown: {
        allOrganisations: 'dashboard.userSettingsComponent.organizationDropdown.allOrganisations'
      }
    }
  },
  declarationNodeDetailsComponent: {
    html: {
      acArticleArticleCategory: 'declarationNodeDetailsComponent.html.acArticleArticleCategory',
      acArticleMaterialCategory: 'declarationNodeDetailsComponent.html.acArticleMaterialCategory',
      acArticleMixtureCategory: 'declarationNodeDetailsComponent.html.acArticleMixtureCategory',
      acInEuTypes: 'declarationNodeDetailsComponent.html.acInEuTypes',
      combinedSUILabel: 'declarationNodeDetailsComponent.html.combinedSUILabel',
      dossierName: 'declarationNodeDetailsComponent.html.dossierName',
      dossierStatusLabel: 'declarationNodeDetailsComponent.html.dossierStatusLabel',
      heading: {
        scipInformation: 'declarationNodeDetailsComponent.html.heading.scipInformation'
      },
      label: {
        casNumber: 'declarationNodeDetailsComponent.html.label.casNumber',
        downloadDossier: 'declarationNodeDetailsComponent.html.label.downloadDossier',
        imdsScipNumber: 'declarationNodeDetailsComponent.html.label.imdsScipNumber',
        imdsScipSubmissionNumber: 'declarationNodeDetailsComponent.html.label.imdsScipSubmissionNumber',
        isValidImdsScipNumber: 'declarationNodeDetailsComponent.html.label.isValidImdsScipNumber',
        openInEcha: 'declarationNodeDetailsComponent.html.label.openInEcha',
        percentageRange: 'declarationNodeDetailsComponent.html.label.percentageRange'
      },
      imdsScipNumberNotSpaces: 'declarationNodeDetailsComponent.html.imdsScipNumberNotSpaces',
      imdsScipNumberFormatNotValid: 'declarationNodeDetailsComponent.html.imdsScipNumberFormatNotValid',
      organizationLabel: 'declarationNodeDetailsComponent.html.organizationLabel',
      otherArticleIdentifiersLabel: 'declarationNodeDetailsComponent.html.otherArticleIdentifiersLabel',
      otherMaterialCategoryText: 'declarationNodeDetailsComponent.html.otherMaterialCategoryText',
      otherMaterialCategoryTextTooltip: 'declarationNodeDetailsComponent.html.otherMaterialCategoryTextTooltip',
      otherNamesLabel: 'declarationNodeDetailsComponent.html.otherNamesLabel',
      scipNumberLabel: 'declarationNodeDetailsComponent.html.scipNumberLabel',
      submissionNumberLabel: 'declarationNodeDetailsComponent.html.submissionNumberLabel',
      vdaMaterialCategoriesLabel: 'declarationNodeDetailsComponent.html.vdaMaterialCategoriesLabel',
      vdaMixtureCategoriesLabel: 'declarationNodeDetailsComponent.html.vdaMixtureCategoriesLabel',
      forceResubmissionLabel: 'declarationNodeDetailsComponent.html.forceResubmissionLabel'
    },
    useImdsScipNumber: {
      groupDescription: 'declarationNodeDetailsComponent.useImdsScipNumber.groupDescription',
      radioButtonLabel: {
        yes: 'declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.yes',
        no: 'declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.no'
      }
    },
    safeuseinstructions: {
      groupDescription: 'declarationNodeDetailsComponent.safeuseinstructions.groupDescription',
      radioButtonLabel: {
        noNeedToProvide: 'declarationNodeDetailsComponent.safeuseinstructions.radioButtonLabel.noNeedToProvide',
        provide: 'declarationNodeDetailsComponent.safeuseinstructions.radioButtonLabel.provide'
      },
      textAreaLabel: {
        safeUseInstructionText: 'declarationNodeDetailsComponent.safeuseinstructions.textAreaLabel.safeUseInstructionText'
      }
    }
  },
  dossierDto: {
    requestedType: {
      PARTS_ONLY: 'dossierDto.requestedType.PARTS_ONLY',
      REFERENCING: 'dossierDto.requestedType.REFERENCING',
      STANDARD: 'dossierDto.requestedType.STANDARD'
    },
    status: {
      ALL_PARTS_COMPLETED: 'dossierDto.status.ALL_PARTS_COMPLETED',
      DISPATCHED: 'dossierDto.status.DISPATCHED',
      DOSSIER_FAILED_TO_CREATE: 'dossierDto.status.DOSSIER_FAILED_TO_CREATE',
      DOSSIER_FILE_CREATED: 'dossierDto.status.DOSSIER_FILE_CREATED',
      DOSSIER_FILE_IN_PREPARATION: 'dossierDto.status.DOSSIER_FILE_IN_PREPARATION',
      DOSSIER_REQUESTED: 'dossierDto.status.DOSSIER_REQUESTED',
      DOSSIER_SENT_TO_ECHA: 'dossierDto.status.DOSSIER_SENT_TO_ECHA',
      DOWNLOADED: 'dossierDto.status.DOWNLOADED',
      FAILED: 'dossierDto.status.FAILED',
      ONE_OR_MORE_FAILED: 'dossierDto.status.ONE_OR_MORE_FAILED',
      PASSED: 'dossierDto.status.PASSED',
      PENDING: 'dossierDto.status.PENDING',
      SUBMISSION_EMPTY: 'dossierDto.status.SUBMISSION_EMPTY',
      SUBMITTED: 'dossierDto.status.SUBMITTED',
      VALIDATION_FAILED: 'dossierDto.status.VALIDATION_FAILED',
      VALIDATION_SUCCEEDED: 'dossierDto.status.VALIDATION_SUCCEEDED',
      DOSSIER_TOO_LARGE: 'dossierDto.status.DOSSIER_TOO_LARGE'
    },
    tooltip: {
      ALL_PARTS_COMPLETED: 'dossierDto.tooltip.ALL_PARTS_COMPLETED',
      DISPATCHED: 'dossierDto.tooltip.DISPATCHED',
      DOSSIER_FAILED_TO_CREATE: 'dossierDto.tooltip.DOSSIER_FAILED_TO_CREATE',
      DOSSIER_FILE_CREATED: 'dossierDto.tooltip.DOSSIER_FILE_CREATED',
      DOSSIER_FILE_IN_PREPARATION: 'dossierDto.tooltip.DOSSIER_FILE_IN_PREPARATION',
      DOSSIER_REQUESTED: 'dossierDto.tooltip.DOSSIER_REQUESTED',
      DOSSIER_SENT_TO_ECHA: 'dossierDto.tooltip.DOSSIER_SENT_TO_ECHA',
      DOWNLOADED: 'dossierDto.tooltip.DOWNLOADED',
      FAILED: 'dossierDto.tooltip.FAILED',
      ONE_OR_MORE_FAILED: 'dossierDto.tooltip.ONE_OR_MORE_FAILED',
      PASSED: 'dossierDto.tooltip.PASSED',
      PENDING: 'dossierDto.tooltip.PENDING',
      SUBMITTED: 'dossierDto.tooltip.SUBMITTED',
      VALIDATION_FAILED: 'dossierDto.tooltip.VALIDATION_FAILED',
      VALIDATION_SUCCEEDED: 'dossierDto.tooltip.VALIDATION_SUCCEEDED',
      DOSSIER_TOO_LARGE: 'dossierDto.tooltip.DOSSIER_TOO_LARGE'
    },
    type: {
      FULL: 'dossierDto.type.FULL',
      SIMPLIFIED: 'dossierDto.type.SIMPLIFIED'
    }
  },
  dossierErrorDetailsDialogComponent: {
    html: {
      contactSupport: 'dossierErrorDetailsDialogComponent.html.contactSupport',
      dossierErrorDialogTitle: 'dossierErrorDetailsDialogComponent.html.dossierErrorDialogTitle',
      errorHeader: 'dossierErrorDetailsDialogComponent.html.errorHeader',
      errorParsingFallback: 'dossierErrorDetailsDialogComponent.html.errorParsingFallback',
      technicalDetails: 'dossierErrorDetailsDialogComponent.html.technicalDetails'
    }
  },
  dossierSummaryComponent: {
    html: {
      dossierNameLabel: 'dossierSummaryComponent.html.dossierNameLabel',
      dossierRemarkLabel: 'dossierSummaryComponent.html.dossierRemarkLabel',
      lastDossierStatus: 'dossierSummaryComponent.html.lastDossierStatus',
      partNumber: 'dossierSummaryComponent.html.partNumber',
      productDossier: 'dossierSummaryComponent.html.productDossier',
      productName: 'dossierSummaryComponent.html.productName',
      scipReadinessLabel: 'dossierSummaryComponent.html.scipReadinessLabel',
      type: 'dossierSummaryComponent.html.type'
    }
  },
  downloadDialogComponent: {
    html: {
      allResults: 'downloadDialogComponent.html.allResults',
      currentPage: 'downloadDialogComponent.html.currentPage',
      dialogTitle: 'downloadDialogComponent.html.dialogTitle',
      download: 'downloadDialogComponent.html.download',
      downloadData: 'downloadDialogComponent.html.downloadData',
      performanceInfo: 'downloadDialogComponent.html.performanceInfo',
      selectData: 'downloadDialogComponent.html.selectData'
    }
  },
  downloadService: {
    msg: {
      downloadError: 'downloadService.msg.downloadError'
    }
  },
  echaProfileSetup: {
    confirmation: {
      confirmDeletionAcceptLabel: 'echaProfileSetup.confirmation.confirmDeletionAcceptLabel',
      confirmDeletionHeader: 'echaProfileSetup.confirmation.confirmDeletionHeader',
      confirmDeletionRejectLabel: 'echaProfileSetup.confirmation.confirmDeletionRejectLabel',
      confirmDeletionText: 'echaProfileSetup.confirmation.confirmDeletionText'
    }
  },
  echaProfileSetupComponent: {
    addAccount: 'echaProfileSetupComponent.addAccount',
    deleteAccount: 'echaProfileSetupComponent.deleteAccount',
    editAccount: 'echaProfileSetupComponent.editAccount',
    html: {
      EchaAccounts: 'echaProfileSetupComponent.html.EchaAccounts',
      editEchaAccount: 'echaProfileSetupComponent.html.editEchaAccount',
      header: 'echaProfileSetupComponent.html.header'
    }
  },
  editProductDialogComponent: {
    html: {
      acArticleArticleCategory: 'editProductDialogComponent.html.acArticleArticleCategory',
      acInEuTypes: 'editProductDialogComponent.html.acInEuTypes',
      dialogTitle: 'editProductDialogComponent.html.dialogTitle',
      msg: {
        productInProgressError: 'editProductDialogComponent.html.msg.productInProgressError',
        productsUpdateError: 'editProductDialogComponent.html.msg.productsUpdateError',
        saveSuccess: 'editProductDialogComponent.html.msg.saveSuccess'
      },
      organization: 'editProductDialogComponent.html.organization',
      otherName: 'editProductDialogComponent.html.otherName',
      productsTable: {
        column: {
          productName: 'editProductDialogComponent.html.productsTable.column.productName',
          productNumber: 'editProductDialogComponent.html.productsTable.column.productNumber'
        },
        tableTitle: 'editProductDialogComponent.html.productsTable.tableTitle'
      },
      requestType: 'editProductDialogComponent.html.requestType',
      saveUseInstructionsGroup: 'editProductDialogComponent.html.saveUseInstructionsGroup',
      saveUseInstructionsGroupNeeded: 'editProductDialogComponent.html.saveUseInstructionsGroupNeeded',
      saveUseInstructionsGroupNeededDefault: 'editProductDialogComponent.html.saveUseInstructionsGroupNeededDefault',
      saveUseInstructionsGroupNeededInclude: 'editProductDialogComponent.html.saveUseInstructionsGroupNeededInclude',
      saveUseInstructionsGroupNotNeeded: 'editProductDialogComponent.html.saveUseInstructionsGroupNotNeeded'
    },
    safeuseinstructions: {
      groupDescription: 'editProductDialogComponent.safeuseinstructions.groupDescription',
      radioButtonLabel: {
        noNeedToProvide: 'editProductDialogComponent.safeuseinstructions.radioButtonLabel.noNeedToProvide',
        provide: 'editProductDialogComponent.safeuseinstructions.radioButtonLabel.provide'
      },
      textAreaLabel: {
        safeUseInstructionText: 'editProductDialogComponent.safeuseinstructions.textAreaLabel.safeUseInstructionText'
      }
    }
  },
  enums: {
    dossierNames: {
      includeYourOwnText: 'enums.dossierNames.includeYourOwnText',
      orgUnitName: 'enums.dossierNames.orgUnitName',
      orgUnitNameExample: 'enums.dossierNames.orgUnitNameExample',
      otherExample: 'enums.dossierNames.otherExample',
      productDescription: 'enums.dossierNames.productDescription',
      productDescriptionExample: 'enums.dossierNames.productDescriptionExample',
      productName: 'enums.dossierNames.productName',
      productNameExample: 'enums.dossierNames.productNameExample',
      productNumber: 'enums.dossierNames.productNumber',
      productNumberExample: 'enums.dossierNames.productNumberExample',
      vpNumber: 'enums.dossierNames.vpNumber',
      vpNumberExample: 'enums.dossierNames.vpNumberExample',
      vpProductName: 'enums.dossierNames.vpProductName',
      vpProductNameExample: 'enums.dossierNames.vpProductNameExample'
    },
    inEUTypes: {
      EU_IMPORTED: 'enums.inEUTypes.EU_IMPORTED',
      EU_PRODUCED: 'enums.inEUTypes.EU_PRODUCED',
      EU_PRODUCED_AND_IMPORTED: 'enums.inEUTypes.EU_PRODUCED_AND_IMPORTED',
      NO_DATA: 'enums.inEUTypes.NO_DATA'
    },
    pait: {
      PINumber: 'enums.pait.PINumber',
      VPNumber: 'enums.pait.VPNumber'
    },
    recentSearchTypeEnum: {
      products: 'enums.recentSearchTypeEnum.products',
      submissions: 'enums.recentSearchTypeEnum.submissions'
    }
  },
  identifierUtils: {
    EAN: 'identifierUtils.EAN',
    GPC: 'identifierUtils.GPC',
    GTIN: 'identifierUtils.GTIN',
    ISBN: 'identifierUtils.ISBN',
    JAN: 'identifierUtils.JAN',
    UDI: 'identifierUtils.UDI',
    batchNumber: 'identifierUtils.batchNumber',
    catalogueNumber: 'identifierUtils.catalogueNumber',
    itemNumber: 'identifierUtils.itemNumber',
    other: 'identifierUtils.other',
    partNumber: 'identifierUtils.partNumber',
    referenceNumber: 'identifierUtils.referenceNumber',
    serialNumber: 'identifierUtils.serialNumber'
  },
  logoutComponent: {
    usermessage: 'logoutComponent.usermessage'
  },
  materialSelectDialogComponent: {
    html: {
      availableMaterialCategories: 'materialSelectDialogComponent.html.availableMaterialCategories',
      column: {
        categories: 'materialSelectDialogComponent.html.column.categories',
        selection: 'materialSelectDialogComponent.html.column.selection'
      },
      dialogTitle: 'materialSelectDialogComponent.html.dialogTitle',
      selectedMaterialCategories: 'materialSelectDialogComponent.html.selectedMaterialCategories'
    }
  },
  mixtureSelectDialogComponent: {
    html: {
      availableMixtureCategories: 'mixtureSelectDialogComponent.html.availableMixtureCategories',
      column: {
        categories: 'mixtureSelectDialogComponent.html.column.categories',
        selection: 'mixtureSelectDialogComponent.html.column.selection'
      },
      dialogTitle: 'mixtureSelectDialogComponent.html.dialogTitle',
      selectedMixtureCategories: 'mixtureSelectDialogComponent.html.selectedMixtureCategories'
    }
  },
  multiInputComponent: {
    html: {
      clearButtonLabel: 'multiInputComponent.html.clearButtonLabel',
      findButtonLabel: 'multiInputComponent.html.findButtonLabel'
    }
  },
  notificationService: {
    notification: {
      header: {
        ERROR: 'notificationService.notification.header.ERROR',
        INFO: 'notificationService.notification.header.INFO',
        SUCCESS: 'notificationService.notification.header.SUCCESS',
        WARNING: 'notificationService.notification.header.WARNING'
      }
    }
  },
  organizationGroupService: {
    msg: {
      error: {
        creatingOrganizationGroup: 'organizationGroupService.msg.error.creatingOrganizationGroup'
      }
    }
  },
  organizationTableComponent: {
    html: {
      echaLegalEntity: 'organizationTableComponent.html.echaLegalEntity',
      organizationGroup: 'organizationTableComponent.html.organizationGroup',
      organizationName: 'organizationTableComponent.html.organizationName',
      organizationStatus: 'organizationTableComponent.html.organizationStatus',
      tablecell: {
        organizationActive: 'organizationTableComponent.html.tablecell.organizationActive',
        organizationNotActive: 'organizationTableComponent.html.tablecell.organizationNotActive'
      },
      organizationInfo: 'organizationTableComponent.html.organizationInfo',
      organizationSuccessNotification: 'organizationTableComponent.html.organizationSuccessNotification',
      organizationErrorNotification: 'organizationTableComponent.html.organizationErrorNotification',
      verifyButton: 'organizationTableComponent.html.verifyButton',
      organizationErrorDialogTitle: 'organizationTableComponent.html.organizationErrorDialogTitle'
    }
  },
  organizationTableEditor: {
    html: {
      active: 'organizationTableEditor.html.active',
      defaultOrganization: 'organizationTableEditor.html.defaultOrganization',
      echaLegalEntity10Chars: 'organizationTableEditor.html.echaLegalEntity10Chars',
      echaLegalEntityNotSpaces: 'organizationTableEditor.html.echaLegalEntityNotSpaces',
      echaLegalEntityUUID: 'organizationTableEditor.html.echaLegalEntityUUID',
      echaUsername: 'organizationTableEditor.html.echaUsername',
      echaUsernameTooltip: 'organizationTableEditor.html.echaUsernameTooltip',
      fullDossierSubmission: 'organizationTableEditor.html.fullDossierSubmission',
      organizationGroup: 'organizationTableEditor.html.organizationGroup',
      organizationName: 'organizationTableEditor.html.organizationName',
      organizationNameMinLength: 'organizationTableEditor.html.organizationNameMinLength',
      organizationNameNotSpaces: 'organizationTableEditor.html.organizationNameNotSpaces',
      primaryOrganization: 'organizationTableEditor.html.primaryOrganization',
      secretKeyAtLeast10Chars: 'organizationTableEditor.html.secretKeyAtLeast10Chars',
      secretKeyWithInvalid: 'organizationTableEditor.html.secretKeyWithInvalid',
      secretS2SKey: 'organizationTableEditor.html.secretS2SKey',
      setAsDefault: 'organizationTableEditor.html.setAsDefault',
      status: 'organizationTableEditor.html.status',
      verifyButton: 'organizationTableEditor.html.verifyButton',
      organizationSuccessNotification: 'organizationTableComponent.html.organizationSuccessNotification',
      organizationErrorNotification: 'organizationTableEditor.html.organizationErrorNotification',
      organizationErrorDialogTitle: 'organizationTableEditor.html.organizationErrorDialogTitle'
    }
  },
  otherArticleIdentifierDialogComponent: {
    html: {
      dialogHeader: 'otherArticleIdentifierDialogComponent.html.dialogHeader',
      notification: {
        validationError: 'otherArticleIdentifierDialogComponent.html.notification.validationError'
      },
      panelHeader: 'otherArticleIdentifierDialogComponent.html.panelHeader'
    },
    ts: {
      button: {
        add: 'otherArticleIdentifierDialogComponent.ts.button.add',
        delete: 'otherArticleIdentifierDialogComponent.ts.button.delete'
      },
      column: {
        identifierType: 'otherArticleIdentifierDialogComponent.ts.column.identifierType',
        identifierValue: 'otherArticleIdentifierDialogComponent.ts.column.identifierValue'
      }
    }
  },
  otherNameDialogComponent: {
    html: {
      dialogHeader: 'otherNameDialogComponent.html.dialogHeader',
      notification: {
        validationError: 'otherNameDialogComponent.html.notification.validationError'
      },
      panelHeader: 'otherNameDialogComponent.html.panelHeader'
    },
    ts: {
      button: {
        add: 'otherNameDialogComponent.ts.button.add',
        delete: 'otherNameDialogComponent.ts.button.delete'
      },
      column: {
        identifierType: 'otherNameDialogComponent.ts.column.identifierType',
        identifierValue: 'otherNameDialogComponent.ts.column.identifierValue'
      }
    }
  },
  otherNameUtils: {
    brand: 'otherNameUtils.brand',
    model: 'otherNameUtils.model',
    other: 'otherNameUtils.other',
    type: 'otherNameUtils.type'
  },
  preferencePageComponent: {
    html: {
      header: 'preferencePageComponent.html.header'
    },
    reset: 'preferencePageComponent.reset',
    clear: 'preferencePageComponent.clear',
    confirmClearAllHeader: 'preferencePageComponent.confirmClearAllHeader',
    confirmClearAllText: 'preferencePageComponent.confirmClearAllText',
    confirm: 'preferencePageComponent.confirm',
    cancel: 'preferencePageComponent.cancel'
  },
  preferencesComponent: {
    html: {
      dossierSummary: {
        costumNameTextLabel: 'preferencesComponent.html.dossierSummary.costumNameTextLabel',
        costumRemarkTextLabel: 'preferencesComponent.html.dossierSummary.costumRemarkTextLabel'
      },
      message: 'preferencesComponent.html.message',
      otherMaterialCategoryText: 'preferencesComponent.html.otherMaterialCategoryText',
      otherMaterialCategoryTextTooltip: 'preferencesComponent.html.otherMaterialCategoryTextTooltip',
      partInformation: {
        acArticle: 'preferencesComponent.html.partInformation.acArticle',
        acArticleMaterialCategory: 'preferencesComponent.html.partInformation.acArticleMaterialCategory',
        acArticleMixtureCategory: 'preferencesComponent.html.partInformation.acArticleMixtureCategory',
        acIdentifierTypes: 'preferencesComponent.html.partInformation.acIdentifierTypes',
        acInEUTypes: 'preferencesComponent.html.partInformation.acInEUTypes',
        description: 'preferencesComponent.html.partInformation.description',
        header: 'preferencesComponent.html.partInformation.header',
        resulutionUserName: 'preferencesComponent.html.partInformation.resulutionUserName',
        submitAs: 'preferencesComponent.html.partInformation.submitAs'
      },
      productDossierSubmission: {
        description: 'preferencesComponent.html.productDossierSubmission.description',
        dossierType: 'preferencesComponent.html.productDossierSubmission.dossierType',
        exampleDossierName: 'preferencesComponent.html.productDossierSubmission.exampleDossierName',
        exampleDossierRemark: 'preferencesComponent.html.productDossierSubmission.exampleDossierRemark',
        header: 'preferencesComponent.html.productDossierSubmission.header',
        otherNames: 'preferencesComponent.html.productDossierSubmission.otherNames',
        otherNamesDescription: 'preferencesComponent.html.productDossierSubmission.otherNamesDescription',
        resolutionUserName: 'preferencesComponent.html.productDossierSubmission.resolutionUserName',
        resolutionUserNameTwo: 'preferencesComponent.html.productDossierSubmission.resolutionUserNameTwo'
      },
      productInformation: {
        acArticle: 'preferencesComponent.html.productInformation.acArticle',
        acIdentifierTypes: 'preferencesComponent.html.productInformation.acIdentifierTypes',
        acInEUTypes: 'preferencesComponent.html.productInformation.acInEUTypes',
        defaultPrimaryArticleIdentifierType: 'preferencesComponent.html.productInformation.defaultPrimaryArticleIdentifierType',
        description: 'preferencesComponent.html.productInformation.description',
        header: 'preferencesComponent.html.productInformation.header',
        submitAs: 'preferencesComponent.html.productInformation.submitAs'
      },
      validation: {
        required: 'preferencesComponent.html.validation.required'
      }
    },
    msg: {
      formReset: 'preferencesComponent.msg.formReset',
      saveError: 'preferencesComponent.msg.saveError',
      saveSuccess: 'preferencesComponent.msg.saveSuccess'
    },
    safeuseinstructions: {
      groupDescription: 'preferencesComponent.safeuseinstructions.groupDescription',
      radioButtonLabel: {
        noNeedToProvide: 'preferencesComponent.safeuseinstructions.radioButtonLabel.noNeedToProvide',
        provide: 'preferencesComponent.safeuseinstructions.radioButtonLabel.provide'
      },
      textAreaLabel: {
        alwaysInclude: 'preferencesComponent.safeuseinstructions.textAreaLabel.alwaysInclude',
        useWhenBlank: 'preferencesComponent.safeuseinstructions.textAreaLabel.useWhenBlank'
      }
    }
  },
  productComponent: {
    html: {
      findProducts: 'productComponent.html.findProducts',
      products: 'productComponent.html.products',
      tab: {
        loading: 'productComponent.html.tab.loading'
      }
    }
  },
  productDeclaration: {
    html: {
      label: {
        header: {
          article: 'productDeclaration.html.label.header.article',
          component: 'productDeclaration.html.label.header.component',
          homogeneousMaterial: 'productDeclaration.html.label.header.homogeneousMaterial',
          material: 'productDeclaration.html.label.header.material',
          mixture: 'productDeclaration.html.label.header.mixture',
          semiComponent: 'productDeclaration.html.label.header.semiComponent',
          substance: 'productDeclaration.html.label.header.substance'
        },
        name: {
          article: 'productDeclaration.html.label.name.article',
          component: 'productDeclaration.html.label.name.component',
          homogeneousMaterial: 'productDeclaration.html.label.name.homogeneousMaterial',
          material: 'productDeclaration.html.label.name.material',
          mixture: 'productDeclaration.html.label.name.mixture',
          semiComponent: 'productDeclaration.html.label.name.semiComponent',
          substance: 'productDeclaration.html.label.name.substance'
        }
      },
      partNumber: 'productDeclaration.html.partNumber',
      type: 'productDeclaration.html.type'
    }
  },
  productDeclarationComponent: {
    html: {
      articleLabel: 'productDeclarationComponent.html.articleLabel',
      countColumnHeader: 'productDeclarationComponent.html.countColumnHeader',
      emptyRootNode: 'productDeclarationComponent.html.emptyRootNode',
      header: {
        productDeclarationLabel: 'productDeclarationComponent.html.header.productDeclarationLabel'
      },
      homogeneousMaterialLabel: 'productDeclarationComponent.html.homogeneousMaterialLabel',
      infoColumnHeader: 'productDeclarationComponent.html.infoColumnHeader',
      isDummy: 'productDeclarationComponent.html.isDummy',
      isReferenceOwn: 'productDeclarationComponent.html.isReferenceOwn',
      isSVHCRelevant: 'productDeclarationComponent.html.isSVHCRelevant',
      mixtureLabel: 'productDeclarationComponent.html.mixtureLabel',
      nameColumnHeader: 'productDeclarationComponent.html.nameColumnHeader',
      noLongerRelevant: 'productDeclarationComponent.html.noLongerRelevant',
      numberColumnHeader: 'productDeclarationComponent.html.numberColumnHeader',
      semicomponentOrComponentLabel: 'productDeclarationComponent.html.semicomponentOrComponentLabel',
      substanceLabel: 'productDeclarationComponent.html.substanceLabel'
    },
    typescript: {
      errorMessage: {
        downloadError: 'productDeclarationComponent.typescript.errorMessage.downloadError',
        errorRetrievingProductdeclaration: 'productDeclarationComponent.typescript.errorMessage.errorRetrievingProductdeclaration',
        errorRetrievingProducts: 'productDeclarationComponent.typescript.errorMessage.errorRetrievingProducts',
        productDeclarationInProcessError: 'productDeclarationComponent.typescript.errorMessage.productDeclarationInProcessError'
      }
    }
  },
  productDetailsComponent: {
    msg: {
      error: {
        loadingProduct: 'productDetailsComponent.msg.error.loadingProduct'
      }
    },
    typescript: {
      uploadDossierButtonText: 'productDetailsComponent.typescript.uploadDossierButtonText'
    }
  },
  productService: {
    msg: {
      error: {
        saveError: 'productService.msg.error.saveError'
      },
      success: {
        saveSuccess: 'productService.msg.success.saveSuccess'
      },
      warning: {
        noChangeDetected: 'productService.msg.warning.noChangeDetected'
      }
    }
  },
  productsComponent: {
    typescript: {
      editSelectedProductButtonText: 'productsComponent.typescript.editSelectedProductButtonText',
      goToDetailsButtonText: 'productsComponent.typescript.goToDetailsButtonText',
      lastSubmissionDate: 'productsComponent.typescript.lastSubmissionDate',
      lastUpdated: 'productsComponent.typescript.lastUpdated',
      msg: {
        productNotLoadedInfo: 'productsComponent.typescript.msg.productNotLoadedInfo'
      },
      uploadDossierButtonText: 'productsComponent.typescript.uploadDossierButtonText'
    }
  },
  productsTableComponent: {
    html: {
      productInformationLoading: 'productsTableComponent.html.productInformationLoading'
    },
    typescript: {
      articleCategoryHeadertext: 'productsTableComponent.typescript.articleCategoryHeadertext',
      buttonBarHeaderText: 'productsTableComponent.typescript.buttonBarHeaderText',
      info: 'productsTableComponent.typescript.info',
      lastSubmissionDate: 'productsTableComponent.typescript.lastSubmissionDate',
      lastUpdated: 'productsTableComponent.typescript.lastUpdated',
      scipRelevantChanged: 'productsTableComponent.typescript.scipRelevantChanged',
      euMarketRelevantChanged: 'productsTableComponent.typescript.euMarketRelevantChanged',
      msg: {
        productsLoadingError: 'productsTableComponent.typescript.msg.productsLoadingError'
      },
      organizationGroup: 'productsTableComponent.typescript.organizationGroup',
      organizationName: 'productsTableComponent.typescript.organizationName',
      orgVerificationstatus: 'productsTableComponent.typescript.orgVerificationstatus',

      otherArticleIdentifiers: 'productsTableComponent.typescript.otherArticleIdentifiers',
      productNameHeaderText: 'productsTableComponent.typescript.productNameHeaderText',
      productNumberHeaderText: 'productsTableComponent.typescript.productNumberHeaderText',
      productionInEUHeaderText: 'productsTableComponent.typescript.productionInEUHeaderText',
      requestedTypeHeaderText: 'productsTableComponent.typescript.requestedTypeHeaderText',
      submissionStatusHeadertext: 'productsTableComponent.typescript.submissionStatusHeadertext'
    }
  },
  profileService: {
    msg: {
      error: {
        addingOrganization: 'profileService.msg.error.addingOrganization',
        deletingOrganization: 'profileService.msg.error.deletingOrganization',
        updatingOrganization: 'profileService.msg.error.updatingOrganization'
      },
      success: {
        addingOrganization: 'profileService.msg.success.addingOrganization',
        deletingOrganization: 'profileService.msg.success.deletingOrganization',
        updatingOrganization: 'profileService.msg.success.updatingOrganization'
      }
    }
  },
  recentSearches: {
    component: {
      filter: 'recentSearches.component.filter',
      heading: 'recentSearches.component.heading',
      noFilterMatches: 'recentSearches.component.noFilterMatches',
      noSearches: {
        substringOne: 'recentSearches.component.noSearches.substringOne',
        substringTwo: 'recentSearches.component.noSearches.substringTwo'
      },
      searchLabel: {
        echaType: 'recentSearches.component.searchLabel.echaType',
        emptyAdvancedSearch: 'recentSearches.component.searchLabel.emptyAdvancedSearch',
        organizationGroups: 'recentSearches.component.searchLabel.organizationGroups',
        organizations: 'recentSearches.component.searchLabel.organizations',
        parentDetails: 'recentSearches.component.searchLabel.parentDetails',
        productName: 'recentSearches.component.searchLabel.productName',
        productNumber: 'recentSearches.component.searchLabel.productNumber',
        requestedType: 'recentSearches.component.searchLabel.requestedType',
        scipNumber: 'recentSearches.component.searchLabel.scipNumber',
        showChildren: 'recentSearches.component.searchLabel.showChildren',
        submissionDateFrom: 'recentSearches.component.searchLabel.submissionDateFrom',
        submissionDateTo: 'recentSearches.component.searchLabel.submissionDateTo',
        submissionNumber: 'recentSearches.component.searchLabel.submissionNumber',
        submissionStatuses: 'recentSearches.component.searchLabel.submissionStatuses',
        uploadDateFrom: 'recentSearches.component.searchLabel.uploadDateFrom',
        uploadDateTo: 'recentSearches.component.searchLabel.uploadDateTo',
        scipRelevantChangedFrom: 'recentSearches.component.searchLabel.scipRelevantChangedFrom',
        scipRelevantChangedTo: 'recentSearches.component.searchLabel.scipRelevantChangedTo',
        euMarketRelevantChangedFrom: 'recentSearches.component.searchLabel.euMarketRelevantChangedFrom',
        euMarketRelevantChangedTo: 'recentSearches.component.searchLabel.euMarketRelevantChangedTo',
        productLoadingState: 'recentSearches.component.searchLabel.productLoadingState'
      }
    }
  },
  reportService: {
    typescript: {
      notification: {
        reportFailure: 'reportService.typescript.notification.reportFailure',
        reportSuccess: 'reportService.typescript.notification.reportSuccess'
      }
    }
  },
  scipTable: {
    filter: {
      combobox: {
        selectedLabel: 'scipTable.filter.combobox.selectedLabel'
      }
    }
  },
  search: {
    service: {
      advanced: 'search.service.advanced',
      datePicker: {
        from: 'search.service.datePicker.from',
        to: 'search.service.datePicker.to'
      },
      echaDossier: {
        ALL: 'search.service.echaDossier.ALL',
        header: 'search.service.echaDossier.header'
      },
      legalEntityGroup: 'search.service.legalEntityGroup',
      organization: 'search.service.organization',
      parentDetails: 'search.service.parentDetails',
      productInformation: 'search.service.productInformation',
      productName: 'search.service.productName',
      productNumber: 'search.service.productNumber',
      productSearch: 'search.service.productSearch',
      productLoadingState: 'search.service.productLoadingState',
      quick: 'search.service.quick',
      scipNumber: 'search.service.scipNumber',
      showChildren: 'search.service.showChildren',
      submissionInformation: 'search.service.submissionInformation',
      submissionNumber: 'search.service.submissionNumber',
      submissionSearch: 'search.service.submissionSearch',
      submissionStatus: {
        submissionStatus: 'search.service.submissionStatus.submissionStatus'
      },
      uploadType: {
        ALL: 'search.service.uploadType.ALL'
      },
      uploadTypes: 'search.service.uploadTypes'
    }
  },
  simplifiedNotificationSubmissionComponent: {
    buttons: {
      next: 'simplifiedNotificationSubmissionComponent.buttons.next',
      previous: 'simplifiedNotificationSubmissionComponent.buttons.previous'
    },
    dossierName: 'simplifiedNotificationSubmissionComponent.dossierName',
    dossierRemark: 'simplifiedNotificationSubmissionComponent.dossierRemark',
    error: {
      selectAtLeastOneOrganization: 'simplifiedNotificationSubmissionComponent.error.selectAtLeastOneOrganization',
      submissionFailed: 'simplifiedNotificationSubmissionComponent.error.submissionFailed'
    },
    html: {
      nextStep: 'simplifiedNotificationSubmissionComponent.html.nextStep',
      previousStep: 'simplifiedNotificationSubmissionComponent.html.previousStep',
      requestedSimplifiedNotifications: 'simplifiedNotificationSubmissionComponent.html.requestedSimplifiedNotifications',
      selectOrganizationsManually: 'simplifiedNotificationSubmissionComponent.html.selectOrganizationsManually',
      selection: {
        disabledToolTipForOthersFromGroup: 'simplifiedNotificationSubmissionComponent.html.selection.disabledToolTipForOthersFromGroup',
        header: 'simplifiedNotificationSubmissionComponent.html.selection.header',
        label: 'simplifiedNotificationSubmissionComponent.html.selection.label',
        lowerRadioButton: 'simplifiedNotificationSubmissionComponent.html.selection.lowerRadioButton',
        originalFullDossiers: 'simplifiedNotificationSubmissionComponent.html.selection.originalFullDossiers',
        othersFromGroup: 'simplifiedNotificationSubmissionComponent.html.selection.othersFromGroup',
        upperRadioButton: 'simplifiedNotificationSubmissionComponent.html.selection.upperRadioButton'
      },
      submit: 'simplifiedNotificationSubmissionComponent.html.submit',
      validation: {
        required: 'simplifiedNotificationSubmissionComponent.html.validation.required'
      }
    },
    info: {
      noSimplifiedSelecedSent: 'simplifiedNotificationSubmissionComponent.info.noSimplifiedSelecedSent'
    },
    internalRemark: 'simplifiedNotificationSubmissionComponent.internalRemark',
    msg: {
      submissionSuccessful: 'simplifiedNotificationSubmissionComponent.msg.submissionSuccessful'
    },
    organization: 'simplifiedNotificationSubmissionComponent.organization',
    productName: 'simplifiedNotificationSubmissionComponent.productName',
    productNumber: 'simplifiedNotificationSubmissionComponent.productNumber',
    selectOrganization: 'simplifiedNotificationSubmissionComponent.selectOrganization',
    submitSimplifiedNotification: 'simplifiedNotificationSubmissionComponent.submitSimplifiedNotification'
  },
  submissionComponent: {
    html: {
      findSubmissions: 'submissionComponent.html.findSubmissions',
      simplifiedNotifications: 'submissionComponent.html.simplifiedNotifications',
      submissions: 'submissionComponent.html.submissions',
      tab: {
        loading: 'submissionComponent.html.tab.loading'
      }
    },
    typescript: {
      goToDetailsButtonText: 'submissionComponent.typescript.goToDetailsButtonText',
      openInIuclid: 'submissionComponent.typescript.openInIuclid',
      simplifierNotificationButton: 'submissionComponent.typescript.simplifierNotificationButton',
      submissionDate: 'submissionComponent.typescript.submissionDate'
    }
  },
  submissionDetails: {
    html: {
      form: {
        button: {
          downloadDossier: 'submissionDetails.html.form.button.downloadDossier'
        },
        field: {
          articleName: 'submissionDetails.html.form.field.articleName',
          dossierName: 'submissionDetails.html.form.field.dossierName',
          dossierType: 'submissionDetails.html.form.field.dossierType',
          fileName: 'submissionDetails.html.form.field.fileName',
          notificationType: 'submissionDetails.html.form.field.notificationType',
          partNumber: 'submissionDetails.html.form.field.partNumber',
          productName: 'submissionDetails.html.form.field.productName',
          scipNumber: 'submissionDetails.html.form.field.scipNumber',
          submissionNumber: 'submissionDetails.html.form.field.submissionNumber',
          submittedStatus: 'submissionDetails.html.form.field.submittedStatus',
          type: 'submissionDetails.html.form.field.type'
        },
        header: {
          aboutTheProduct: 'submissionDetails.html.form.header.aboutTheProduct'
        }
      },
      panel: {
        header: {
          productDossierInfo: 'submissionDetails.html.panel.header.productDossierInfo',
          submissionReport: 'submissionDetails.html.panel.header.submissionReport',
          validationReport: 'submissionDetails.html.panel.header.validationReport'
        }
      },
      table: {
        header: {
          documentName: 'submissionDetails.html.table.header.documentName',
          level: 'submissionDetails.html.table.header.level',
          message: 'submissionDetails.html.table.header.message',
          rule: 'submissionDetails.html.table.header.rule'
        }
      }
    }
  },
  submissionDetailsComponent: {
    msg: {
      error: {
        loadingDossier: 'submissionDetailsComponent.msg.error.loadingDossier'
      }
    },
    typescript: {
      closeButtonText: 'submissionDetailsComponent.typescript.closeButtonText',
      goToProductButtonText: 'submissionDetailsComponent.typescript.goToProductButtonText',
      openInIuclid: 'submissionDetailsComponent.typescript.openInIuclid'
    }
  },
  submissionTableComponent: {
    grid: {
      dossierInternalRemarks: 'submissionTableComponent.grid.dossierInternalRemarks',
      dossierName: 'submissionTableComponent.grid.dossierName',
      dossierRemark: 'submissionTableComponent.grid.dossierRemark',
      download: 'submissionTableComponent.grid.download',
      fileName: 'submissionTableComponent.grid.fileName',
      info: 'submissionTableComponent.grid.info',
      organizationGroup: 'submissionTableComponent.grid.organizationGroup',
      organizationName: 'submissionTableComponent.grid.organizationName',
      panelHeaderTitle: 'submissionTableComponent.grid.panelHeaderTitle',
      parentId: 'submissionTableComponent.grid.parentId',
      parentProduct: 'submissionTableComponent.grid.parentProduct',
      productName: 'submissionTableComponent.grid.productName',
      productNumber: 'submissionTableComponent.grid.productNumber',
      requestedType: 'submissionTableComponent.grid.requestedType',
      scipId: 'submissionTableComponent.grid.scipId',
      simplifiedSubs: 'submissionTableComponent.grid.simplifiedSubs',
      subStatus: 'submissionTableComponent.grid.subStatus',
      submissionDate: 'submissionTableComponent.grid.submissionDate',
      submissionNumber: 'submissionTableComponent.grid.submissionNumber',
      type: 'submissionTableComponent.grid.type',
      updatedAt: 'submissionTableComponent.grid.updatedAt'
    },
    html: {
      simplified: {
        notApplicable: 'submissionTableComponent.html.simplified.notApplicable'
      }
    },
    ts: {
      searchError: {
        message: 'submissionTableComponent.ts.searchError.message'
      }
    }
  },
  twinTableSelectComponent: {
    html: {
      availableOrganizations: 'twinTableSelectComponent.html.availableOrganizations',
      selectedOrganizations: 'twinTableSelectComponent.html.selectedOrganizations'
    }
  },
  uiUserSettingsService: {
    msg: {
      warning: {
        restoringSettings: 'uiUserSettingsService.msg.warning.restoringSettings',
        savingSettings: 'uiUserSettingsService.msg.warning.savingSettings'
      }
    }
  },
  unsavedChangesDialogComponent: {
    btn: {
      cancel: 'unsavedChangesDialogComponent.btn.cancel',
      discard: 'unsavedChangesDialogComponent.btn.discard',
      resume: 'unsavedChangesDialogComponent.btn.resume',
      save: 'unsavedChangesDialogComponent.btn.save'
    },
    msg: {
      applyToAll: 'unsavedChangesDialogComponent.msg.applyToAll',
      canSave: {
        contentMessage: 'unsavedChangesDialogComponent.msg.canSave.contentMessage',
        contentTitle: 'unsavedChangesDialogComponent.msg.canSave.contentTitle'
      },
      header: 'unsavedChangesDialogComponent.msg.header',
      noSave: {
        contentMessage: 'unsavedChangesDialogComponent.msg.noSave.contentMessage',
        contentTitle: 'unsavedChangesDialogComponent.msg.noSave.contentTitle'
      }
    }
  },
  uploadProductDialogComponent: {
    html: {
      buttons: {
        upload: 'uploadProductDialogComponent.html.buttons.upload'
      },
      defaultOrganization: 'uploadProductDialogComponent.html.defaultOrganization',
      notVerifyOrganization: 'uploadProductDialogComponent.html.notVerifyOrganization',
      verifyFailOrganization: 'uploadProductDialogComponent.html.verifyFailOrganization',
      dialogTitle: 'uploadProductDialogComponent.html.dialogTitle',
      dossierType: 'uploadProductDialogComponent.html.dossierType',
      dossiersTable: {
        column: {
          dossierName: 'uploadProductDialogComponent.html.dossiersTable.column.dossierName',
          dossierRemarks: 'uploadProductDialogComponent.html.dossiersTable.column.dossierRemarks',
          internalDossierRemarks: 'uploadProductDialogComponent.html.dossiersTable.column.internalDossierRemarks',
          organization: 'uploadProductDialogComponent.html.dossiersTable.column.organization',
          productName: 'uploadProductDialogComponent.html.dossiersTable.column.productName',
          productNumber: 'uploadProductDialogComponent.html.dossiersTable.column.productNumber',
          requestedType: 'uploadProductDialogComponent.html.dossiersTable.column.requestedType',
          requiredError: 'uploadProductDialogComponent.html.dossiersTable.column.requiredError'
        },
        header: 'uploadProductDialogComponent.html.dossiersTable.header'
      },
      otherName: 'uploadProductDialogComponent.html.otherName',
      forceResubmission: 'uploadProductDialogComponent.html.forceResubmission'
    },
    msg: {
      uploadDossierError: 'uploadProductDialogComponent.msg.uploadDossierError',
      uploadDossierSuccess: 'uploadProductDialogComponent.msg.uploadDossierSuccess',
      uploadDossierWarning: 'uploadProductDialogComponent.msg.uploadDossierWarning'
    }
  },
  tabsComponent: {
    html: {
      tab: {
        loading: 'tabsComponent.html.tab.loading'
      }
    }
  }
};
